<template>
  <div v-if="data" class="select__block">
    <p
      class="select__text"
      :style="{ paddingLeft: paddingLeft + 'px' }"
      @click="$emit('click', data.folder)"
    >
      {{ data.folder.name }}
    </p>
    <template v-if="data.childrenFolders && data.childrenFolders.length">
      <SelectBlock
        v-for="folder in data.childrenFolders"
        :key="folder.folder.id"
        :data="folder"
        :padding-left="offsetPaddingLeft"
        @click="$emit('click', $event)"
      ></SelectBlock>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SelectBlock',
  props: {
    paddingLeft: {},
    data: {}
  },
  computed: {
    offsetPaddingLeft() {
      return +this.paddingLeft + 10;
    }
  }
};
</script>
